import { Grid } from '@mui/material';
import Stepper from '../../Components/Stepper';
import CircularProgressBar from '../../Components/CircularProgressBar'
import { steps, redirectTo } from '../../Helper/AppStepperData';
import { useSelector } from 'react-redux';

function Sidebar(props) {
  const { isSmallScreen, isObjectionScreen } = props;
  const stepper = useSelector(state => state.storeState.stepper) || [];

  return (
    <div style={{ width: "100%" }}>
      <Grid container direction={isSmallScreen ? "row" : "column"} wrap={"nowrap"} style={isSmallScreen ? { overflowY: 'auto' } : {}}>
        {!isSmallScreen && <Grid item style={{ borderTop: '1px solid #ffffff75', borderBottom: '1px solid #ffffff75', marginTop: '20px', padding: '10px 30px', display: 'flex', alignItems: 'center' }}>
          <CircularProgressBar
            isObjectionScreen={isObjectionScreen}
            style={{ display: 'flex', alignItems: 'center' }}
            text={"Complete"}
          />
        </Grid>}
        {
          steps.map((ele, index) => (
            <Grid item key={index}>
              <Stepper
                name={ele.name}
                isSmallScreen={isSmallScreen}
                redirectTo={redirectTo[ele.name]}
                isObjectionScreen={isObjectionScreen}
                completed={stepper[index] || (stepper[index - 1] && stepper[index - 1] === steps[index - 1].nestedSteps.length)}
                percentage={stepper[index] ? (stepper[index] / ele.nestedSteps.length) * 100 : 0}
                isActive={ele.redirectTo.includes(window.location.pathname)}
              />
            </Grid>
          ))
        }
      </Grid>
    </div>
  )
}

export default Sidebar;